import PasswordChecks from './password-checks';

export default PasswordChecks;
